import { lazy } from 'react';
import reducer from './state/reducers';
import { getStore } from '@AppRedux/store';
import checkAuth from '@Utils/checkAuth';

const store = getStore();

const AvailableJobList = lazy(() =>
    import('./AvailableJobList').then(async module => {
        await checkAuth();
        const auth = getStore().getState().auth;
        if(auth.isAuthenticated) {
            store.injectReducer('availableJobList', reducer.listReducer);
            return module;
        }
    })
);

const AvailableJobRoutes = [
    {
        label: 'Available Jobs',
        path: '/HRAutomation/AvailableJobs',
        menuName: 'hrAutomation',
        component: AvailableJobList,
        icon: 'fa-list',
        exact: true,
        showNav: true, 
        public: true, 
    },
]

export default AvailableJobRoutes;